module.exports = __webpack_public_path__ + "static/media/screenshot_history_6_ru.f33abb2f.png";